module.exports = __webpack_public_path__ + "img/20190716161917937.7cf115ff.png";